
import { Button, Card, CardContent, Chip, GridLegacy as Grid, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import dayjs from '../../../utils/dayjs-setup';
import { useState,useEffect, useContext } from "react";
import { DatePickerInputWithLabel } from "../../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../../store/AppStore";
import { AxiosInstance, DateFormatString,  DialogType,  EstadosPedido,  FormActions, FormatPrice, usuarioEntity } from "../../../utils/constants";
import * as yup from "yup";
import { FilterForm } from "../../../components/form/filter-form";
import { useNavigate } from "react-router-dom";





const ItemListPedido = (props)=>{

  return (
    <Card>
      <CardContent>
      <Typography sx={{ fontSize: 15 }} color="text.primary" gutterBottom>
          <strong>PEDIDO ID:</strong> {props.cod}
      </Typography>
      <Typography sx={{ fontSize: 14 }} color="text.primary" gutterBottom>
          <strong>CLIENTE:</strong> {props.nombre_cliente}
      </Typography>
      <Typography sx={{ fontSize: 14 }} color="text.primary" gutterBottom>
          <strong>FECHA DE ENTREGA:</strong> {dayjs(props.fecha_entrega).format(DateFormatString)}
      </Typography>
      <Typography sx={{ fontSize: 14 }} color="text.primary" gutterBottom>
          <strong>HORA DE RECOGIDA:</strong> {dayjs(props.fecha_entrega).format("HH:mm:ss")}
      </Typography>
      <Typography sx={{ fontSize: 14 }} color="text.primary" gutterBottom>
          <strong>TIPO DE ENTREGA:</strong> {props.tipo_entrega_descripcion}
      </Typography>
      
       <Chip size="small" color={EstadosPedido[props.estado_nombre].color} label={EstadosPedido[props.estado_nombre].label} />

      <Button onClick={e=>props.onChangeStatusPedido(props.estado_nombre === 'RECIBIDO'?'EN-ALISTAMIENTO':'')} size="small" variant="contained" color="primary" >{props.estado_nombre === 'RECIBIDO'?'Alistar pedido':'Continuar'}  </Button>


      </CardContent>
    </Card>

  )

}


const CardResumeBuild = ({
  title="",
  label_numer="",
  extraLabel=""
})=>(
  <Card >
      <CardContent>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          {title}
        </Typography>
        <Typography variant="h5" component="div">
          {label_numer}
        </Typography>
       <Typography sx={{ mb: 1.5 }} color="text.secondary">
          {extraLabel}
        </Typography> 
      
      </CardContent>
{/*       <CardActions>
        <Button size="small">Learn More</Button>
      </CardActions> */}
    </Card>
)

const schema = yup.object({
  cod_usuario: yup.string().required(),

  productos_asociados: yup.array().of(
    yup.object().shape({
      label:yup.string(),
      value:yup.number()
    })
  ).optional()
}).required();
const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  fecha_entrega:dayjs(),
};

const schemaFilter = yup.object({
  

}).required();

export const AlistamientoInit = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store} = useContext( AppContext );


  const [totalPage,setTotalCompras] = useState({
    "count_en_alistamiento": 0,
    "count_pendientes": 0,

  });
  const navigate = useNavigate();


    useEffect(()=>{

      
      loadInitData();

    },[]);
    

    useEffect(()=>{
  
      loadItems( filterSearchPagination.filter_search?false:true,filterSearchPagination );
    },[filterSearchPagination]);


    const loadInitData = async()=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      await loadItems(false);
     
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    }


  const  setFilterAply = (filtros)=>{
    console.log({filtros});

    setFilterSearchPagination({
      ...filterSearchPagination,
      ...filtros
    });
  }

    const loadItems =  async (loading=true,filtros=filterSearchPagination)=>{
      console.log({filtros,filterSearchPagination});
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }
    
     let {data:{value}} = await AxiosInstance.post("maestros-marketplace/get-pedidos-list-alistamiento",{
      ...filtros,
      producto:filtros.product_select?.value,
      fecha_entrega:dayjs(filtros.fecha_entrega).format(DateFormatString),
      page_number:filtros.page_number+1
     });
     setDataSetProductos([...value?.listado?.data]);
     setTotalCompras({
      count_en_alistamiento:value.count_en_alistamiento,
      count_pendientes:value.count_pendientes
     });


     setTotalRows(value?.listado?.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
     });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };

  
    const CambiarEstadoPedido = (pedidoData,status)=>{

      if ( status ){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });

        AxiosInstance.post("maestros-marketplace/update-status-pedido",{
          cod_pedido:pedidoData.cod,
          action:"EN-ALISTAMIENTO"
        }).then(  ({data})=>{

          navigate(`/plataforma/detalle-alistamiento/${pedidoData.cod}`);

        }).catch(error=>{

          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:error.msg,
                type:DialogType.peligro,
                isVisible:true
            }
        });

        }).finally(()=>{
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });
        });

      }else{

        navigate(`/plataforma/detalle-alistamiento/${pedidoData.cod}`);

      }
       
    }



  
    const columnsTable = [
      {
      
       key:"pedido_item",
       keyValue:"pedido_item",
       label:"",
       headerRender:(props)=>props.label,
       bodyRender:({info})=><ItemListPedido onChangeStatusPedido={ estatus=>CambiarEstadoPedido(info,estatus)} {...info} />,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
     
     
       
 
    ];
   




    const InputFilters = [
      {
        grid:{
          xs:12,
          md:4,
          sm:12
        },
        InputComponent:DatePickerInputWithLabel,
        keyValue:"fecha_entrega",
        inputProps:{
          size:'small',
          disabled:true
        },
        InputComponentProps:{
          label:"Fecha de entrega",
          //views:['month', 'year'],
          fullWidth:true,
          isLoading:false,
          inputFormat:"DD-MM-YYYY",
          value:null,
          size:'small',
          //onInputChange:searchMunicipiosOrigen,
         
        }
      },
     /*  {
        grid:{
          xs:3,
          md:3,
          sm:3
        },
        InputComponent:AutoCompleteInputWithLabel,
        keyValue:"product_select",
        InputComponentProps:{
          label:"Producto",
          fullWidth: true,
          isLoading: false,
          multiple:false,
          size:'small',

          onInputChange: searcProductoAsociado,
          options: productFilterList || [],
          noOptionsText: "Lista vacia",
          getOptionLabel: (option) => option.label,
          isOptionEqualToValue: (option, value) => option.value === value.value,
          filterOptions:(x) => x,
        }
      },
      {
        grid:{
          xs:6,
          md:3,
          sm:6
        },
        InputComponent:AutoCompleteInputWithLabel,
        keyValue:"proveedor_select",
        InputComponentProps:{
          label:"Proveedor",
          fullWidth: true,
          isLoading: false,
          multiple:false,
          size:'small',
          onInputChange: onSearchProveedor,
          options: proveedorOptions || [],
          noOptionsText: "Lista vacia",
          getOptionLabel: (option) => option.label,
          isOptionEqualToValue: (option, value) => option.value === value.value,
          filterOptions:(x) => x,
        }
      }, */
      ];

    return (<>
   
   
    <Grid container spacing={2} >
        <Grid item sm={12} xs={12} md={10} >

      
          <FilterForm
            buttomDist={
              {
                sx:10,
                md:5
              }
            }
            nameFilter={"Buscar resumen por"}
            inputsFilter={InputFilters}
            schemaValidator={schemaFilter}
            initialValuesFilter={
            {  product_select:filterSearchPagination?.producto,
            
             }
            }
            onApplyFilter={setFilterAply}
          />
       
        

        </Grid>

        <Grid spacing={1} container item sm={12} xs={12} md={12} >
            
            <Grid item sm={6} xs={6} md={6} >
              <CardResumeBuild
              title="PENDIENTES"
              label_numer={totalPage.count_pendientes}
              />
            </Grid>
            <Grid item sm={6} xs={6} md={6} >
              <CardResumeBuild
              title="EN CURSO"
              label_numer={totalPage.count_en_alistamiento}
              />
            </Grid>
            {/* <Grid item sm={6} xs={6} md={4} >
              <CardResumeBuild
              title="Total comision 0.3 %"
              label_numer={`$ ${FormatPrice(totalPage.valor_comision?.toFixed(2))} COP`}
             //  extraLabel="0.3 del total comprado"
              />
            </Grid> */}
        </Grid>

        <Grid item sm={12} xs={12} md={12} >
          <Typography variant="h6" >
              Listado de compras del mes
          </Typography>
        </Grid>
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer >
               <Table >
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( prod=>
                  <TableRow key={prod.cotizacion_cod}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell  >
                          {<Col.bodyRender info={prod} value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}